import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IDeleteJobsData {
  id: string;
}

const deleteCustomGeofence = (postData: IDeleteJobsData) => {
  return http().post(endpoints.job.deleteCustomGeofence, postData);
};

export function useDeleteCustomGeofence() {
  return useMutation({ mutationFn: deleteCustomGeofence, onError: () => undefined });
}
